import React from "react";
import { Link } from "react-router-dom";
import mockIP from "./mockIP";
import "./IP.scss";

const IP = () => {
  return (
    <div className="IP">
      {mockIP.map((product) => (
        <div className="IP-container">
          <Link
            className="IP-container_card"
            key={product.id}
            to={`/iPhoneDetail/${product.id}`}
          >
            <img className="IP-container_card--img" src={product.img}></img>
            <h2 className="IP-container_card--txt">{product.model}</h2>
          </Link>
        </div>
      ))}
    </div>
  );
};

export default IP;
